import { Header, LeftSideBar } from 'components'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

const PrivateLayout = () => {
  return (
    <main>
      <Suspense>
        <Header />
        <section className="bg-gray-100">
          <div className="grid grid-cols-12">
            <div className="col-span-2 p-5">
              <LeftSideBar />
            </div>

            <div className="col-span-10 h-[calc(100vh-120px)] overflow-y-auto p-5">
              <div className="rounded-lg bg-white p-5">
                <Outlet />
              </div>
            </div>
          </div>
        </section>
      </Suspense>
    </main>
  )
}

export default PrivateLayout
